import { View } from "react-native";
import { Button, Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import useDeliveryFulfillments from "../../contexts/DeliveryFulfillmentsContext";

type Props = {
  navigateToPickupLocation: () => void;
};

export default function PickupInfo({ navigateToPickupLocation }: Props) {
  const tailwind = useTailwind();
  const { pickupAddress } = useDeliveryFulfillments();

  if (!pickupAddress) {
    return (
      <Button
        mode="contained"
        style={tailwind("self-start")}
        onPress={navigateToPickupLocation}
      >
        Agregar dirección
      </Button>
    );
  }

  return (
    <View style={tailwind("gap-4")}>
      <View>
        <Text variant="bodyLarge">{pickupAddress.contact_name}</Text>
        <Text variant="bodyLarge">{pickupAddress.address}</Text>
        <Text variant="bodyLarge">{pickupAddress.additional_instructions}</Text>
      </View>
      <Button
        mode="outlined"
        style={tailwind("self-start")}
        onPress={navigateToPickupLocation}
      >
        Editar
      </Button>
    </View>
  );
}
